'use client'

import { getCompanyProfileRoute, Routes } from '@/constants/routes'
import { msg } from '@lingui/core/macro'

const getNormalizedLocale = (): string => {
  if (typeof navigator !== 'undefined') {
    const locale = navigator.language.split('-')[0]
    return locale === 'vi' ? 'vi' : 'en'
  }
  return 'en'
}

export const MENU_LINKS = [
  {
    title: msg`About Us`,
    items: [
      {
        title: msg`Overview`,
        href: Routes.Overview,
        external: false
      },
      // {
      //   title: msg`Our Leaders`,
      //   href: Routes.OurLeaders,
      //   external: false
      // },
      {
        title: msg`Our Journey`,
        href: Routes.OurJourney,
        external: false
      },
      {
        title: msg`Awards & Achievements`,
        href: Routes.Awards,
        external: false
      },
      {
        title: msg`Development orientation`,
        href: Routes.DevelopmentOrientation,
        external: false
      },
      {
        title: msg`Company Profile`,
        href: getCompanyProfileRoute(getNormalizedLocale()),
        isCompanyProfile: true,
        external: true
      },
      {
        title: msg`Sandbox`,
        href: 'https://sandbox.pionegroup.com/',
        external: true
      }
    ]
  },
  {
    title: msg`Services & Solutions`,
    items: [
      {
        title: msg`IoT, AI & Blockchain`,
        href: Routes.IotAiBlockchain,
        external: false
      },
      {
        title: msg`Comprehensive Digital Transformation`,
        href: Routes.DigitalTransformation,
        external: false
      },
      {
        title: msg`Applied Technology Solutions`,
        href: Routes.ApplicationDevelopment,
        external: false
      },
      {
        title: msg`Digital Experience Design (UI/UX)`,
        href: Routes.UiUxDesignBranding,
        external: false
      },
      // {
      //   title: msg`Metaverse & Virtual Environments`,
      //   href: '#',
      //   external: false
      // },
      {
        title: msg`Digital Platforms & Web 3.0`,
        href: Routes.WebsiteDevelopment,
        external: false
      }
      // {
      //   title: msg`Biotechnology & Genetic Encryption`,
      //   href: '#',
      //   external: false
      // },
      // {
      //   title: msg`Quantum Computing (Future Vision)`,
      //   href: '#',
      //   external: false
      // },
      // {
      //   title: msg`Magnetic Technology & New Energy (Long-term Research Vision)`,
      //   href: '#',
      //   external: false
      // }
    ]
  },
  {
    title: msg`Ecosystem`,
    items: [
      {
        title: msg`Pione Wallet`,
        href: Routes.PioneWallet,
        external: false
      },
      {
        title: msg`Pione Super App`,
        href: Routes.PioneSuperApp,
        external: false
      },
      {
        title: msg`Pione House`,
        href: Routes.PioneHouse,
        external: false
      },
      {
        title: msg`Pione Care`,
        href: Routes.PioneCare,
        external: false
      },
      {
        title: msg`Pione Farm`,
        href: Routes.PioneFarm,
        external: false
      },
      {
        title: msg`Pione AI`,
        href: Routes.PioneAI,
        external: false
      },
      {
        title: msg`Pione Swap`,
        href: 'https://pioneswap.com',
        external: true
      },
      {
        title: msg`Pione Mart`,
        href: 'https://pionemart.com',
        external: true
      },
      {
        title: msg`Pione Zero`,
        href: Routes.PioneZero,
        external: false
      }

      // {
      //   title: msg`Pione Games`,
      //   href: '#'
      // },
      // {
      //   title: msg`Pione Star`,
      //   href: '#'
      // },
      // {
      //   title: msg`Pione Node`,
      //   href: '#'
      // },
      // {
      //   title: msg`Pione AI & Bot`,
      //   href: '#'
      // },
      // {
      //   title: msg`Pione Smart`,
      //   href: '#'
      // },
      // {
      //   title: msg`Pione Dapps Store`,
      //   href: '#'
      // }
    ]
  },
  {
    title: msg`News & Events`,
    href: Routes.News,
    external: false
  },
  {
    title: msg`Careers & Culture`,
    href: Routes.CareersCulture,
    external: false
  },
  {
    title: msg`Contact Us`,
    href: Routes.Contact,
    external: false
  },
  {
    title: msg`Collaboration`,
    href: Routes.Collaboration,
    external: false
  }
]

export const FOOTER_LINKS = [
  {
    title: msg`Products`,
    links: [
      { name: msg`PIONE Wallet`, href: Routes.Wallet, external: true },
      { name: msg`PIONE Farm`, href: Routes.Farm, external: true },
      { name: msg`PIONE Care`, href: Routes.Care, external: true },
      { name: msg`PIONE House`, href: Routes.House, external: true },
      { name: msg`PIONE Exchange`, href: Routes.Exchange, external: true },
      { name: msg`PIONE Mart`, href: Routes.Mart, external: true },
      { name: msg`PIONE Swap`, href: Routes.Swap, external: true },
      { name: msg`PIONE AI & Bot`, href: Routes.AI, external: true },
      { name: msg`PIONE NFT`, href: Routes.NFT, external: true }
    ]
  },
  {
    title: msg`Resources`,
    links: [{ name: msg`Contact`, href: Routes.Contact, external: false }]
  },
  {
    title: msg`About`,
    links: [{ name: msg`Blog`, href: Routes.Blog, external: false }]
  },
  {
    title: msg`Legal`,
    links: [
      { name: msg`Terms of Use`, href: Routes.TermsOfUse, external: false },
      { name: msg`Privacy Policy`, href: Routes.PrivacyPolicy, external: false },
      { name: msg`Cookie Policy`, href: Routes.CookiePolicy, external: false }
    ]
  }
]
